import { createContext } from "react";
import { PortalConfiguration } from "types/PortalConfiguration";
import { EMPTY_PORTAL_CONFIGURATION } from "./utils";

export const AppContext = createContext<PortalConfiguration>(EMPTY_PORTAL_CONFIGURATION);
